import { c as _c } from "react/compiler-runtime";
import { IcoChevronRight16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
type InnerDrawerProps = {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onClose: () => void;
};
const InnerDrawer = t0 => {
  const $ = _c(18);
  const {
    children,
    open,
    onClose
  } = t0;
  const t1 = !open;
  let t2;
  if ($[0] !== open || $[1] !== t1) {
    t2 = cx({
      block: open,
      hidden: t1
    });
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <div className="max-h-[40dvh] md:max-h-none md:h-[90vh] flex flex-col overflow-y-auto"><div className={t2}>{children}</div></div>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !open;
  let t5;
  if ($[6] !== open || $[7] !== t4) {
    t5 = cx("flex items-center justify-center", {
      "-rotate-90 md:rotate-180": open,
      "rotate-90 md:rotate-0": t4
    });
    $[6] = open;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IcoChevronRight16 />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <div className={t5}>{t6}</div>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onClose || $[13] !== t7) {
    t8 = <button type="button" className="absolute bottom-0 right-3 translate-y-full md:bottom-auto md:top-2 md:right-0 md:translate-x-full md:translate-y-0 cursor-pointer h-8 py-2 px-1 rounded-b-sm md:rounded-bl-none md:rounded-tr-sm border border-tertiary flex items-center justify-center bg-primary z-toast hover:bg-hover" onClick={onClose}>{t7}</button>;
    $[12] = onClose;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t8) {
    t9 = <div className="relative shrink-0 bg-primary border-b border-tertiary md:shrink md:border-b-0 md:border-r">{t3}{t8}</div>;
    $[15] = t3;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default InnerDrawer;